module.exports = " <div class=vux-group-tip :style=\"{'text-align':align}\"> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/tip/index.vue
// module id = 258
// module chunks = 2